<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <ul class="placeul">
                    <li>号码认证</li>
                    <li>号码认证介绍</li>
                </ul>
            </ul>
        </div>
        <div class="mainindex">
            <div>
                <div style="text-align:center;margin-bottom: 10px;">
                    <strong style="font-size: 20px;color:rgb(100, 164, 248)">号码认证</strong>
                </div>
                <div style="text-align: center;margin-bottom: 10px;">
                    <el-button type="danger" style="margin-left:15px;letter-spacing: 1px;" @click="downloadfile">受理文件下载</el-button>
                    <el-button type="success" style="margin-left:15px;letter-spacing: 1px;" @click="applyauthenticationnumber">申请号码认证</el-button>
                </div>
                <ul style="clear: both; overflow: hidden; padding-left: 15%;width: 70%;">
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber1.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber2.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber3.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber4.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber5.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber6.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber7.jpg" style="width: 100%; display: block;"/>
                    </li>
                    <li>
                        <img src="//www.2office.cn/static/img/authenticationnumber8.jpg" style="width: 100%; display: block;"/>
                    </li>
                </ul>
            </div>
        </div>

        <!--号码认证申请-->
        <div v-show="showApply" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
            top: 0; left: 0;display: block;"/>
        <div class="tip" style="z-index:200;display: block;width:550px;min-height:auto;max-height: 450px; top: 40%;" v-show="showApply">
            <div class="tiptop"><span>号码认证申请</span><a @click="closeShow();"></a></div>
            <ul class="forminfo" style="margin-top:10px;">
                <li style="color: coral; font-size:  18px;">
                    号码认证申请，请先确保下载《受理文件》并按要求填写完整后上传，并上传公司营业执照。再提交申请，未按要求操作可能审核不通过。
                </li>
                <li>
                    <label>上传受理文件<b>*</b></label>
                    <div class="l lh38 pr10" style="margin-left: 10px;">
                        <div class="l w188 pr50">
                            <el-upload
                                style="width:130px"
                                class="upload-demo"
                                :on-success="uploadSuccessTxt"
                                ref="txtPathUpload"
                                :action=txtPathUploadUrl
                                :accept="'*'"
                                :auto-upload="false"
                                :limit="1"
                                :headers="uploadHeaders"
                                :on-change="checkTxtChange"
                                :on-remove="checkTxtRemove"
                                :on-exceed="handleTxtExceed">
                                <el-button size="small" type="danger" round>选择受理文件</el-button>
                            </el-upload>
                        </div>
                        <el-button size="small" type="warning" round @click="submitTxtPath">上传受理文件</el-button>
                    </div>
                </li>
                <li>
                    <label>上传营业执照<b>*</b></label>
                    <div class="l lh38 pr10">
                        <div class="l w188 pr50" style="margin-left: 10px;">
                            <el-upload
                                style="width:130px"
                                class="upload-demo"
                                :on-success="uploadSuccessCompany"
                                ref="companyPathUpload"
                                :action=companyPathUploadUrl
                                :accept="'image/*'"
                                :auto-upload="false"
                                :limit="1"
                                :data="uploadParams"
                                :headers="uploadHeaders"
                                :on-change="checkCompanyChange"
                                :on-remove="checkCompanyRemove"
                                :on-exceed="handleCompanyExceed">
                                <el-button size="small" type="danger" round>选择营业执照</el-button>
                            </el-upload>
                        </div>
                        <el-button type="success" size="small" style="margin-left: -5px;" round @click="submitCompanyPath">上传营业执照并申请</el-button>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data() {
        return {
            txtPath: '',
            companyPath: '',
            uploadHeaders: {},
            uploadParams: {},
            txtPathUploadUrl: this.GLOBAL.serverSrc + '/upload/uploadauthenticationnumbertxtpath.json',
            companyPathUploadUrl : this.GLOBAL.serverSrc + '/upload/uploadauthenticationnumbercompanypath.json',
            showApply: false,
            showFirst: false,
            showThird: false,
        }
    },
    mounted() {
        this.uploadHeaders.token = this.GLOBAL.token;
    },
    methods:{
        //下载受理文件模板
        downloadfile() {
            window.open("//www.2office.cn/authenticationnumber.doc");
        },
        handleTxtExceed() {
            this.$message.error("只能上传一份《受理文件》，修改请先删除。");
        },
        checkTxtChange(file) {
            this.showFirst = true;
        },
        checkTxtRemove() {
            this.txtPath = '';
            this.showFirst = false;
        },
        //受理文件上传成功回调函数
        uploadSuccessTxt(response){
            if (response.code === '0000000') {
                this.$message({
                    type: 'success',
                    message: "受理文件上传成功!",
                });
                this.txtPath = response.txtPath;
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是doc，docx格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.txtPathUpload.clearFiles();
            }
            else if('0000015' == response.code)
            {
                this.$alert(response.msg);
                this.closeShow();
            }
            else
            {
                this.$alert(response.msg);
                this.$refs.txtPathUpload.clearFiles();
            }
        },
        submitTxtPath(file) {
            if(!this.showFirst)
            {
                this.$alert("请选择《受理文件》");
                return;
            }
            this.$refs.txtPathUpload.submit();
        },
        applyauthenticationnumber() {
            this.$confirm("请确保您的总账户金额大于500元，并且已经下载模板文件,并且已经填写好。", '提示', {
                confirmButtonText: '确认申请', 
                cancelButtonText: '取消申请', 
                type: 'warning'
            }).then( () => {
                this.showApply = true;
            }).catch( () => {
                this.$message({
                    duration: 2000,
                    showClose: true,
                    type: 'error',
                    message: '已取消'
                });
            });
        },
        handleCompanyExceed() {
            this.$message.error("只能上传一份《营业执照》，修改请先删除。");
        },
        checkCompanyChange(file) {
            this.showThird = true;
        },
        checkCompanyRemove() {
            this.showThird = false;
        },
        //营业执照上传成功回调函数
        uploadSuccessCompany(response){
            if (response.code === '0000000') {
                this.$message({
                    type: 'success',
                    message: "申请成功，请耐心等待审核!",
                });
                this.companyPath = response.ompanyPath;
                this.closeShow();
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是gif，jpg，png格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.companyPathUpload.clearFiles();
            }
            else if('0000015' == response.code)
            {
                this.$alert(response.msg);
            }
            else{
                this.$alert(response.msg);
            }
        },
        submitCompanyPath(file) {
            if(this.txtPath == '')
            {
                this.$alert("请上传《受理文件》!");
                return;
            }
            if(!this.showThird)
            {
                this.$alert("请选择《营业执照》");
                return;
            }
            this.uploadParams.txtPath = this.txtPath;
            this.$refs.companyPathUpload.submit();
        },
        closeShow() {
            this.$refs.txtPathUpload.clearFiles();
            this.$refs.companyPathUpload.clearFiles();
            this.txtPath = '';
            this.companyPath = '';
            this.showFirst = false;
            this.showThird = false;
            this.showApply = false;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/authenticationnumber/authenticationnumber.vue